import { addressToString } from '@debbie/common/dist/index.js';
import * as api from '../api/street-view.js';
import q from '../query.js';
export const streetViewEntity = 'street-view';
export const streetViewKey = (address) => `street-view-${address == null ? '' : addressToString(address)}`;
export const useStreetView = (address) => q.query(streetViewKey(address), () => api.getImage(address), [streetViewEntity], { enabled: address != null });
//# sourceMappingURL=index.js.map